import React, { Component } from "react";
import { Accordion } from "semantic-ui-react";

class BusinessCreditCapacity extends Component {
  state = {
    activeIndex: 0,
    rows: [],
  };

  render() {
    return (
      <Accordion fluid styled key={`Business_Section_Nearby`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Business_Nearby_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Credit Capacity Disclaimer
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Business_Nearby_Body`}
          active={this.state.activeIndex === 0}
        >
          <span>
            {
              "Credit Capacity is only an indicator of a business's capacity to pay its bills. These indicators are only a starting point. You should only use Credit Capacity as a part of your overall due diligence. Do not use Credit Capacity as the sole factor in making a decision about credit. We base our scores on a proprietary model that includes multiple factors, including number of years in business, number of employees, lines of business, sales volume and other demographics. We do not possess perfect information and do not guarantee the accuracy, timeliness or completeness of the rating codes. We will not be responsible for any losses resulting from the use of this information"
            }
          </span>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default BusinessCreditCapacity;



// WEBPACK FOOTER //
// ./src/components/reports/Business/BusinessCreditCapacity.js